import formatNumberWithCommas from "components/Common/CommaSeparator"
import { downloadBillPaymentExcel } from "helpers/fakebackend_helper"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Modal, Table } from "reactstrap"
import SimpleBar from "simplebar-react"
import "simplebar-react/dist/simplebar.min.css"
import { paymentAmountList } from "store/actions"

const PaymentsModal = ({ isOpen, toggle, filterResponse }) => {
  const dispatch = useDispatch()

  const paymentListState = state =>
    state.Dashboard?.paymentAmountList?.bill_payment_list
  const paymentList = useSelector(paymentListState)

  useEffect(() => {
    if(isOpen===true){

    dispatch(paymentAmountList({ filter: filterResponse }))
    }
  }, [filterResponse, dispatch,isOpen])

  const handleExport = async () => {
    // Construct the URL for download
    const value = {
      filter: filterResponse,
      type: "Payment",
    }
    const downloadUrl = await downloadBillPaymentExcel(value)
  }

  return (
    <Modal
      className="modal-dialog-centered"
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
        Receipt's List
        </h5>
        <button
          onClick={handleExport}
          type="button"
          className="btn btn-primary btn-sm me-4"
        >
          Export
        </button>
        <button
          onClick={toggle}
          type="button"
          className="close mt-2"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <SimpleBar style={{ maxHeight: "60vh", overflowX: "auto" }}>
          <div style={{ minWidth: "100%" }}>
            <Table className="table table-striped mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Receipt No.</th>
                  <th>Amount</th>
                  <th>Customer</th>
                  <th>Company</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {((paymentList && paymentList) || []).map((row, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{row.receipt_no}</td>
                    <td>{formatNumberWithCommas(row.amount)}</td>
                    <td>{row.customer_name}</td>
                    <td>{row.name}</td>
                    <td>{row.receipt_date}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </SimpleBar>
      </div>
    </Modal>
  )
}

export default PaymentsModal
